import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadPoliciesByIdFailed, loadPoliciesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadPoliciesById(action) {
  try {
    const url = `${BACKEND_URL}/policies/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadPoliciesByIdSuccessful(data.policy));
      yield call(resolveActionPromise(action, data.policy));
    } else {
      yield put(loadPoliciesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadPoliciesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
